export default __webpack_public_path__ + "static/media/Pilgrim's Jerkin of the Aureate.ed9c158c.jpg";